import { isEmpty } from "@utils/lodash";
import { useEffect } from "react";

export const useGetInitialSelectedVariant = ({
  variants,
  selectedVariantId,
  setSelectedVariant,
  defaultVariantIdSelection,
  addonId,
  isCoverSelected,
  showModal
}: {
  variants: any[];
  selectedVariantId: string | null;
  setSelectedVariant: Function;
  defaultVariantIdSelection: string;
  addonId: string;
  isCoverSelected: boolean;
  showModal: boolean;
}) => {
  useEffect(() => {
    if (showModal && !isEmpty(variants)) {
      if (isCoverSelected && selectedVariantId) {
        setSelectedVariant(
          variants?.find((v) => v?.variant_id === selectedVariantId)
        );
      } else {
        setSelectedVariant(
          variants?.find((v) => v?.variant_id === defaultVariantIdSelection)
        );
      }
    }
  }, [addonId, selectedVariantId, showModal]);
};
